import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../domain/models/user';
import { LocalStorageService } from '../services/local-storage.service';

export const jwtHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const version = environment.version;

  let headers = req.headers
    .set('Accept', `application/json`)
    .set('Content-Type', `application/json`)
    .set('Version', version);

  let endpoint = environment.api;
  const localStorageService = new LocalStorageService();
  const user = localStorageService.getItem<User>('user');
  if (user) {
    headers = headers.set('Authorization', `Bearer ${user.accessToken}`);
  }

  if (headers.has('override-url')) {
    endpoint = headers.get('override-url') || endpoint;
    headers = headers.delete('override-url');
  }

  const newReq = req.clone({
    headers,
    url: `${endpoint}${req.url}`,
  });
  return next(newReq);
};
